import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsFindBy } from 'services/WService.js';
import { onlyInteger } from 'hooks/Pipe';
import { wsGetAll } from 'services/WService';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default WithApp(function ModalCuotaColgateIcentivo(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [sellers, setSellers] = useState([]);

  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);

  const [zonas, setZonas] = useState([]);
  const [mesas, setMesas] = useState([]);
  const [canal, setCanal] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listSellers() {
    let response = await wsFindBy('base/seller', { state: 'A', deleted_at: 'null' });
    if (response.success) setSellers(response.data);
  }
  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZonas(response.data);
  }
  async function listMesas() {
    let response = await wsFindBy('base/bureau', {base_zone_id: dataChanging.base_zone_id, state: 'A', delete_at: null});
    if (response.success) setMesas(response.data);
  }

  async function listCanales() {
    let response = await wsGetAll('sale/canal-incentivo');
    if (response.success) setCanal(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        SlpCode: null,
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            SlpCode: item.CODIGOVENDEDOR,
            base_bureau_id: item.MESA,
            base_canal_description: item.CANAL,
            cuota_sin_igv: item.CUOTASINIGV,
            cuota_total: item.CUOTACREMAS,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.SlpCode) {
      setDataChanging((prev) => ({
        ...prev,
        SlpCode: bPartnerSelect?.SlpCode || '',
      }));
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {listSellers();listZones();listCanales();};
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);
  
  useEffect(() => {
    const cuotaSinIgv = parseFloat(dataChanging.cuota_sin_igv) || 0;
    setDataChanging(prev => ({
      ...prev,
      cuota_month_percent: (cuotaSinIgv * 0.55).toFixed(2)
    }));
  }, [dataChanging.cuota_sin_igv]);

  useEffect(() => {
    if (dataChanging.base_zone_id) {
      setMesas([]);
      listMesas();
    }
  }, [dataChanging.base_zone_id])

  return (
    <>
      <Modal
        title={`Nueva Cuota de icentivos para colgate`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.SlpCode
            ? 'sale/cuotas-incentivos'
            : 'sale/cuotas-incentivos/multiple'
        }
        dataForce={
          dataChanging.SlpCode
            ? {
                SlpCode: dataChanging.SlpCode,
                base_bureau_id: dataChanging.base_bureau_id,
              }
            : {
                SlpCode: cuota.valueSearch?.SlpCode,
                customers: bPartnerSelect?.customers
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={sellers}
            getOptionLabel={(item) => `${item.SlpName} (Código: ${item.SlpCode})`}
            renderInput={(params) => (
              <TextField {...params} label="Vendedores" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('SlpCode', item?.SlpCode); setDataImport(null);}}
            value={sellers.find((seller) => seller.SlpCode === dataChanging.SlpCode) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate={['CODIGOVENDEDOR','MESA','CANAL']}
            sortDuplicate="CODIGOVENDEDOR"
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de cuota colgate`,
              fields: ['CODIGOVENDEDOR','MESA','CANAL','CUOTASINIGV','CUOTACREMAS']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.SlpCode ? (
          <>
            <Autocomplete
              disableClearable
              options={zonas}
              required
              getOptionLabel={(item) => `${item.description}`}
              renderInput={(params) => (
                <TextField {...params} label="Zona" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('base_zone_id', item?.id); setDataImport(null);}}
              value={zonas.find((zona) => zona.id === dataChanging.base_zone_id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <Autocomplete
              disableClearable
              options={mesas}
              getOptionLabel={(item) => `${item.description}`}
              renderInput={(params) => (
                <TextField {...params} label="Mesa" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('base_bureau_id', item?.id); setDataImport(null);}}
              value={mesas.find((mesa) => mesa.id === dataChanging.base_bureau_id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Canal</InputLabel>
              <Select
                required
                value={dataChanging.base_canal_id || ''}
                inputProps={{
                  name: 'base_canal_id',
                  onChange: (e) => handleChange('base_canal_id', e.target.value),
                }}
              >
                {canal.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.description}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Cuota sin IGV"
              fullWidth
              type="number"
              name="cuota_sin_igv"
              margin="normal"
              value={dataChanging.cuota_sin_igv || ''}
              onChange={(e) => handleChange('cuota_sin_igv', e.target.value)}
              required
            />
            <TextField
              label="Cuota total Crema"
              fullWidth
              type="number"
              name="cuota_total"
              margin="normal"
              value={dataChanging.cuota_total || ''}
              onChange={(e) => {
                const value = e.target.value;
                if (value === '') {
                  handleChange('cuota_total', '');
                  return;
                }
                const max = parseFloat(dataChanging.cuota_sin_igv) || 0;
                const numericValue = parseFloat(value);
                if (!isNaN(numericValue) && numericValue <= max) {
                  handleChange('cuota_total', numericValue);
                }
              }}
              required
            />
            <TextField
              label="Cuota 55% mensual"
              fullWidth
              type="number"
              name="cuota_month_percent"
              margin="normal"
              value={dataChanging.cuota_month_percent || ''}
              disabled
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});
